const convert2JOSN = str => {
  let op = {}
  try {
    op = JSON.parse(str)
  } catch (err) {
    // eslint-disable-next-line no-console
    if (process.env.NODE_ENV === 'development') console.log(err)
  }
  return op
}

export default {
  convert2JOSN
}
